import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-canvas text-navy-950" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjq45l4rr2xp" />
      <main data-id="element-2" data-mp="3mj6jhwnqi0fz">
        <Hero data-id="element-3" data-mp="3rcj6y3gog175" />
        <SocialProof data-id="element-4" data-mp="3rbrcwx2qabiz" />
        <Testimonials data-id="element-5" data-mp="3rdkie91luppe" />
        <ProblemSection data-id="element-6" data-mp="3rd189ei755lx" />
        <SystemSection data-id="element-7" data-mp="5yi8qe3h5da" />
        <ModulesSection data-id="element-8" data-mp="67znpl2q47d" />
        <BonusSection data-id="element-9" data-mp="4n7g6m8exco" />
        <UrgencySection data-id="element-10" data-mp="82kl3wchwbg" />
        <PricingSection data-id="element-11" data-mp="2zld1d7i6tbah" />
        <MoreResults data-id="element-12" data-mp="2zlv8iz6e19x6" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo557bmuj1l" />
        <FAQ data-id="element-14" data-mp="2zng1ikd20ksx" />
        <ClosingSection data-id="element-15" data-mp="33mowttnqsqql" />
        <SummaryTable data-id="element-16" data-mp="33lwywc6oagx5" />
        <FinalCta data-id="element-17" data-mp="33nghwajpr62m" />
      </main>
      <Footer data-id="element-18" data-mp="33oi3h8ycvayl" />
      <PurchaseNotification data-id="element-19" data-mp="38lrrqla0dgku" />
    </div>;
}